<template>
    <div class="bgFooter">
        <div class="container">
            <footer class="">
                <div class="row py-5 wapHide">
                    <div class="col-6 col-md-2 mb-3">
                        <h5 class="text-white mb-3">关于我们</h5>
                        <ul class="nav flex-column">
                            <li class="nav-item mb-2">
                                <router-link to="/about" class="nav-link p-0 text-white"> 公司简介
                                </router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/about" class="nav-link p-0 text-white"> 资质荣誉
                                </router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/about" class="nav-link p-0 text-white"> 企业文化
                                </router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="col-6 col-md-2 mb-3">
                        <h5 class="text-white mb-3">解决方案</h5>
                        <ul class="nav flex-column">
                            <li class="nav-item mb-2">
                                <router-link to="/service" class="nav-link p-0 text-white">专业音响系统</router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/meet" class="nav-link p-0 text-white">数字会议系统</router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/paper" class="nav-link p-0 text-white">无纸化会议系统</router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/service" class="nav-link p-0 text-white">智能中控管理系统</router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/service" class="nav-link p-0 text-white">智能舞台灯光系统</router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/service" class="nav-link p-0 text-white">广播系统</router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/service" class="nav-link p-0 text-white">显示系统</router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/service" class="nav-link p-0 text-white">舞台幕布系统</router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="col-6 col-md-2 mb-3">
                        <h5 class="text-white mb-3">技术支持</h5>
                        <ul class="nav flex-column">
                            <li class="nav-item mb-2">
                               <router-link to="/technical/faq" class="nav-link p-0 text-white">
                                    常见问题
                                </router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/technical/device" class="nav-link p-0 text-white">
                                    设备答疑
                                </router-link>
                            </li>
                            <li class="nav-item mb-2">
                                <router-link to="/technical/service" class="nav-link p-0 text-white">售后服务
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-6 col-md-2 mb-3">
                        <h5 class="text-white mb-3">智能体服务</h5>
                        <ul class="nav flex-column">
                            <li class="nav-item mb-2">
                               <router-link to="/agent" class="nav-link p-0 text-white">
                                    智能体开发
                                </router-link>
                            </li>
                        </ul>
                    </div>

                    <div class="col-md-4">
                        <div class="text-end text-white">
                            <span class="fs-6">全国服务热线</span>
                            <p class="fs-1">186-1269-8839</p>
                            <img src="../../assets/images/code.jpg" alt="" width="120">
                            <p class="fs-14 mt-1 mb-0">扫码添加客服微信 </p>
                        </div>
                    </div>
                </div>

                <div class="text-center py-4 btmBorder">
                    <p class="text-white fs-14 mb-0">Copyright © 北京纵硕科技有限公司 All Rights Reserved.   京ICP备2022018713号-2 </p>
                </div>
            </footer>
        </div>
    </div>
</template>
<script>
   export default {
    name: 'PageBrand',
    props: {
        msg: String
    },
  }
</script>
<style lang="less" scoped>
    .bgFooter{
        background: #1b1b1b;
        .btmBorder{
            border-top: 1px solid #414141;
        }
    }
</style>